import React from 'react';

const FormattedDate = ({ dateString }) => {
    try {
        const date = new Date(dateString);
        //Extract year, month, and day
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');

        //Extract the hour and minute
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return <div>{`${month}/${day}/${year} `}</div>;
        // return <div>{`${month}/${day}/${year} ${hours}:${minutes}`}</div>;
     } catch(error) {
         console.error('Invalid date string', error)
         return <div>Invalid Date</div>;
     }
};

export default FormattedDate;

